var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"extensionTimeCell font-h6-regular yx-color-text-primary"},[_c('span',[_vm._v(_vm._s(_vm._f("formatDate")(`${_vm.row[_vm.column['startTime']]}`)))]),_c('span',{staticClass:"ml-4 mr-4"},[_vm._v("至")]),_c('span',[_vm._v(_vm._s(_vm._f("formatDate")(`${_vm.row[_vm.column['endTime']]}`)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }